var _classCallCheck = require("/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _inherits = require("/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var _createSuper = require("/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");
var Base = require('./base');
var FetchService = /*#__PURE__*/function (_Base) {
  "use strict";

  _inherits(FetchService, _Base);
  var _super = _createSuper(FetchService);
  function FetchService() {
    _classCallCheck(this, FetchService);
    return _super.apply(this, arguments);
  }
  _createClass(FetchService, [{
    key: "request",
    value: function request(options, params) {
      var fetchOptions = Object.assign({}, options, params.connection);
      fetchOptions.headers = Object.assign({
        Accept: 'application/json'
      }, this.options.headers, fetchOptions.headers);
      if (options.body) {
        fetchOptions.body = JSON.stringify(options.body);
      }
      var fetch = this.connection;
      return fetch(options.url, fetchOptions).then(this.checkStatus).then(function (response) {
        if (response.status === 204) {
          return null;
        }
        return response.json();
      });
    }
  }, {
    key: "checkStatus",
    value: function checkStatus(response) {
      if (response.ok) {
        return response;
      }
      return response.json().then(function (error) {
        error.response = response;
        throw error;
      });
    }
  }]);
  return FetchService;
}(Base);
module.exports = FetchService;